import type { Cache, UpdatesConfig, Variables } from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

import type {
  TuitionImportImplementationCreateMutation,
  TuitionImportImplementationUpdateMutation,
} from '@/graphql/generated/graphql';

const tuitionImportImplementation = {
  tuitionImportImplementationCreate: (
    _data: TuitionImportImplementationCreateMutation,
    __: Variables,
    cache: Cache,
  ) => {
    invalidateQuery('tuitionImportImplementations', cache);
  },
  tuitionImportImplementationUpdate: (
    _data: TuitionImportImplementationUpdateMutation,
    __: Variables,
    cache: Cache,
  ) => {
    invalidateQuery(['tuitionImportImplementations', 'tuitionImportImplementation'], cache);
  },
};

export default tuitionImportImplementation as UpdatesConfig['Mutation'];
